<template>
  <div>
    <button @click="showGame">
      显示高频互动
    </button>
    <div class="game-wrap" v-show="visible">
      <div class="game-inner" ref="gameInner" :style="{width: gameWidth + 'px'}">
        <span class="game-close" @click="visible = false">关闭</span>
        <GamePlayer @onGamePlaySubmit="onGamePlaySubmit" ref="gamePlayer" />
      </div>
    </div>
  </div>
</template>

<script>
import GamePlayer from '@/components/GamePlayer.vue'
export default {
  components: {
    GamePlayer
  },
  data() {
    return {
      visible: false,
      gameWidth: 0
    }
  },
  mounted() {
  },
  methods: {
    onGamePlaySubmit() {
      this.visible = false
    },
    showGame() {
      this.visible = true
      this.$nextTick(() => {
        this.gameWidth = this.$refs.gameInner.offsetHeight * 1.5
        this.$refs.gamePlayer.loadGame({
          selectIds: [{
            id: 998,
            uri: '31O33F92459'
          }]
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.game-wrap {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 50vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}
.game-inner {
  position: relative;
  height: 100%;
  .game-close {
    position: absolute;
    color: #fff;
    right: -50px;
    top: 0;
  }
}
</style>